import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import auth from "../services/auth";

const authSlice = createSlice({
  name: 'authSlice',
  initialState: {},
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload
    },
    setOpenLogin: (state, action) => {
      state.openLogin = action.payload
    },
    setOrderQty: (state, action) => {
      state.orderQty = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
    .addMatcher(
      isAnyOf(auth.endpoints.getToken.matchFulfilled),
      (state, action) => {
        state.token = action.payload.token;
        window.localStorage.setItem('token', action.payload.token);
        window.localStorage.setItem('user', JSON.stringify(action.payload.user));
      }
    )
    .addMatcher(
      isAnyOf(auth.endpoints.getInfor.matchFulfilled),
      (state, action) => {
        if(action.payload){
          const infor = JSON.parse(action.payload);
          if(infor && infor.length > 0){
            if(infor[0].ERROREX){
              state.openLogin = true;
            }
            state.infor = infor[0];
            window.localStorage.setItem('infor', JSON.stringify(infor[0]));
          }
          else{
            state.infor = {};
            window.localStorage.setItem('infor', JSON.stringify('{}'));
          }
        }
      }
    )
  },
});
export const { setToken, setOpenLogin, setOrderQty } = authSlice.actions;
export default authSlice.reducer;